import React, { Fragment, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import DoctorAvailableSlotPicker from "../../DoctorAvailableSlotPicker/DoctorAvailableSlotPicker";
import styles from "./DoctorSlots.module.css";
import { useAuth0, withAuth0 } from "@auth0/auth0-react";

const DoctorSlots = (props) => {
  
  const { getAccessTokenSilently } = useAuth0();
  const GetAuthToken = async () => {
    const token = await getAccessTokenSilently();
    return token;
  };
  const [selectedDoctorIdBySlot, setSelectedDoctorIdBySlot] = useState("");
  const [selectedDateBySlot, setSelectedDateBySlot] = useState("");

  const [selectedTimeBySlot, setSelectedTimeBySlot] = useState("");
  const [selectedData, setSelectedData] = useState(null)

  

  const [dateRange, setDateRange] = useState([]);
  useEffect(() => {
    if (props.dateRangeList && props.dateRangeList.length != 0) {
      setDateRange(props.dateRangeList);
    }
    return () => {
      setDateRange([]);
      setSelectedData(null)
    };
  }, [props.dateRangeList]);

  const saveButtonHandler = () => {
    props.selectDoctor({
      doctor_pms_ref_id:
      Number(selectedDoctorIdBySlot),
      doctorName:selectedData?.doctor_name, 
      appointment_length:selectedData?.appointment_length
    });
    props.selectAppointmentTime(selectedTimeBySlot);
    props.selectedAppointmentDate(selectedDateBySlot);
    props.onClose();
  };
  const cancelButtonHandler = () => {
    // props.selectDoctor("");
    // props.selectAppointmentTime("");
    // props.selectedAppointmentDate("");
    props.onClose();
  };

  let renderDoctorSlots = () => {
    if (dateRange && dateRange.length === 0) {
      return (
        <div className={styles.doctorSlots__notification}>
          <p>Please select the doctor and the date range. </p>
        </div>
      );
    }else if (dateRange && dateRange.length>0  && props.clickedFetchButton.length===0){
      return (
        <div className={styles.doctorSlots__notification}>
          <p>Please click on Fetch available slots button, To get the available slots. </p>
        </div>
      );

    }
    return (
      <div className={styles.doctorSlots__dateRange}>
        {dateRange &&
          dateRange.map((date,index) => (
            <DoctorAvailableSlotPicker
              GetAuthToken={GetAuthToken}
              date={date}
              selectedDoctor={props.selectedDoctor}
              setSelectedTimeSlot={props.setSelectedTimeSlot}
              selectedTimeSlot={props.selectedTimeSlot}
              setSelectedDoctorIdBySlot={(val) =>
                setSelectedDoctorIdBySlot(val)
              }
              setSelectedDateBySlot={(val) => setSelectedDateBySlot(val)}
              setSelectedTimeBySlot={(val) => setSelectedTimeBySlot(val)}
              clickedFetchButton={props.clickedFetchButton}
              centerId={props.centerId}
              setSelectedData={(val)=>setSelectedData(val)}
              Index={index}
              fromDate={props.fromDate}
              toDate={props.toDate}


            />
          ))}
      </div>
    );
  };
  return (
    <Fragment>
      <div className={styles.doctorSlots}>{renderDoctorSlots()}</div>
      {dateRange && dateRange.length > 0 && props.clickedFetchButton.length ? (
        <div className={styles.doctorSlots__buttons}>
          <Button
            className={styles.material__uiSaveButton}
            onClick={saveButtonHandler}
            disabled={!props.selectedTimeSlot}
          >
            Select
          </Button>
          <Button
            className={styles.material__uiCancelButton}
            onClick={cancelButtonHandler}
          >
            Cancel
          </Button>
        </div>
      ):""}
    </Fragment>
  );
};

export default DoctorSlots;
